"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledImageDisplayWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledImageDisplayWrapper = styled_components_1.default.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: auto;
  margin-bottom: 0.5rem;

  .image-display-heading {
    margin-bottom: ${({ theme }) => theme.spacing(2)};
    font-size: 1em;
  }

  .image-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, 192px);
    gap: ${({ theme }) => theme.spacing(2)};

    .border-wrapper {
      padding-top: 0;
    }
  }
`;
